export default __webpack_public_path__ + "assets/images/banner_resources-1c45838074f96548ba3c62ca422fcf38.png";